import React from 'react';
import { ECSettingsProvider } from './ecSettings';
import { ProvidersProvider } from './providers';
import { ProviderDetailsProvider } from './providerDetails';
import { ProductsProvider } from './products';
import { ProductDetailsProvider } from './productDetails';
import { SearchProductsProvider } from './searchProducts';
import { SearchProvidersProvider } from './searchProviders';
import { ShoppingCartProvider } from './shoppingCart';
import { ProviderTagsProvider } from './providerTags';

const providers = [
  ECSettingsProvider,
  ProvidersProvider,
  ProviderDetailsProvider,
  ProductsProvider,
  ProductDetailsProvider,
  SearchProductsProvider,
  SearchProvidersProvider,
  ShoppingCartProvider,
  ProviderTagsProvider,
];

const ContextProviders = ({ children }) => providers.reduceRight((nestedProvider, Parent) => (
  <Parent>{nestedProvider}</Parent>
), children);

const withECContextProviders = (Component) => (props) => (
  <ContextProviders>
    <Component {...props} />
  </ContextProviders>
);

export default withECContextProviders;
